package com.fireavert.properties.shared.data_models

import kotlinx.serialization.Serializable

@Serializable
enum class Mode(val value: String) {
    Active("Active"),
    Mute("Mute"),
    Test("Test"),
    Install("Install"),
    Archive("Archive")
}